<template>
  <div class="flex flex-row items-center pr-3" style="gap: 20px">
    <div v-html="icon.icon"></div>
    <div class="flex flex-col">
      <p class="text-base">
        Vehicle <span class="font-bold">{{ license_plate }}</span>
        {{ this.icon.msg }}
        <span v-if="msg == 'Over Speed'">
          at
          <span class="text-white font-bold"> {{ detail }}km/h </span>
        </span>
      </p>
      <p class="mt-2">- {{ fleet_group ? fleet_group : 'Unknown Fleet' }}</p>
    </div>
    <audio
      ref="audioElement"
      :src="require('@/assets/audio/alert.mp3')"
      muted></audio>
  </div>
</template>

<script>
export default {
  props: {
    alert_id: String,
    initialTime: Number,
    license_plate: String,
    msg: String,
    detail: Number,
    fleet_group: String,
  },
  data() {
    return {
      icon_list: [],
      icon: {},
    }
  },
  computed: {
    iconContent() {
      return this.icon.icon || '' // Ensure icon.icon is not null or undefined
    },
  },
  created() {
    this.icon_list = [
      {
        type: 'Over Speed',
        icon: `<svg
            xmlns="http://www.w3.org/2000/svg"
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none">
            <g clip-path="url(#clip0_356_16936)">
              <path
                d="M33.9667 14.2833L31.9167 17.3666C32.9053 19.3384 33.3893 21.5247 33.3253 23.7295C33.2613 25.9343 32.6513 28.0888 31.55 30H8.45002C7.01864 27.5168 6.42551 24.6385 6.75859 21.7918C7.09166 18.945 8.33321 16.2814 10.2992 14.1957C12.2651 12.11 14.8508 10.7134 17.6729 10.2128C20.495 9.71223 23.4033 10.1344 25.9667 11.4166L29.05 9.36664C25.9108 7.35367 22.1872 6.45165 18.4748 6.80487C14.7624 7.15809 11.2758 8.74614 8.57251 11.315C5.86926 13.8839 4.10563 17.2851 3.56372 20.9747C3.02181 24.6642 3.73294 28.429 5.58336 31.6666C5.87421 32.1704 6.29184 32.5893 6.79474 32.8817C7.29764 33.1741 7.86831 33.3298 8.45002 33.3333H31.5334C32.1207 33.3356 32.6983 33.1827 33.2075 32.89C33.7168 32.5974 34.1397 32.1753 34.4334 31.6666C35.969 29.0065 36.7396 25.9738 36.6602 22.9032C36.5808 19.8327 35.6544 16.8438 33.9834 14.2666L33.9667 14.2833ZM17.65 25.6833C17.9596 25.9932 18.3272 26.2391 18.7319 26.4068C19.1365 26.5746 19.5703 26.6609 20.0084 26.6609C20.4464 26.6609 20.8802 26.5746 21.2848 26.4068C21.6895 26.2391 22.0571 25.9932 22.3667 25.6833L31.8 11.5333L17.65 20.9666C17.3401 21.2762 17.0942 21.6438 16.9265 22.0485C16.7587 22.4532 16.6724 22.8869 16.6724 23.325C16.6724 23.763 16.7587 24.1968 16.9265 24.6014C17.0942 25.0061 17.3401 25.3737 17.65 25.6833Z"
                fill="#F2F2F2"
              />
            </g>
            <defs>
              <clipPath id="clip0_356_16936">
                <rect width="40" height="40" fill="white" />
              </clipPath>
            </defs>
          </svg>`,
        msg: 'exceeds the speed limit',
      },
      {
        type: 'Main Battery Disconnected (Power Loss)',
        icon: `<svg
            xmlns="http://www.w3.org/2000/svg"
            width="38"
            height="38"
            viewBox="0 0 38 38"
            fill="none">
            <g clip-path="url(#clip0_384_23082)">
              <path
                d="M24.8108 6.33332H22.1666V3.16666H15.8333V6.33332H13.1891C12.0333 6.33332 11.0833 7.28332 11.0833 8.43916V32.7117C11.0833 33.8833 12.0333 34.8333 13.1891 34.8333H24.795C25.9666 34.8333 26.9166 33.8833 26.9166 32.7275V8.43916C26.9166 7.28332 25.9666 6.33332 24.8108 6.33332ZM20.5833 28.5H17.4166V25.3333H20.5833V28.5ZM20.5833 22.1667H17.4166V14.25H20.5833V22.1667Z"
                fill="#F2F2F2"
              />
            </g>
            <defs>
              <clipPath id="clip0_384_23082">
                <rect width="38" height="38" fill="white" />
              </clipPath>
            </defs>
          </svg>`,
        msg: 'main battery is disconnected',
      },
    ]

    this.icon = this.icon_list.find((icon) => icon.type === this.msg) || {
      type: 'DEFAULT',
      icon: `<svg
          xmlns="http://www.w3.org/2000/svg"
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none">
          <g clip-path="url(#clip0_356_16936)">
            <path
              d="M20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0ZM20 37.5C10.6112 37.5 2.5 29.3888 2.5 20C2.5 10.6112 10.6112 2.5 20 2.5C29.3888 2.5 37.5 10.6112 37.5 20C37.5 29.3888 29.3888 37.5 20 37.5Z"
              fill="#F2F2F2"
            />
            <path
              d="M20 10C18.8954 10 18 10.8954 18 12V24C18 25.1046 18.8954 26 20 26C21.1046 26 22 25.1046 22 24V12C22 10.8954 21.1046 10 20 10Z"
              fill="#F2F2F2"
            />
            <path
              d="M20 28C19.4477 28 19 28.4477 19 29C19 29.5523 19.4477 30 20 30C20.5523 30 21 29.5523 21 29C21 28.4477 20.5523 28 20 28Z"
              fill="#F2F2F2"
            />
          </g>
          <defs>
            <clipPath id="clip0_356_16936">
              <rect width="40" height="40" fill="white" />
            </clipPath>
          </defs>
        </svg>`,
      msg: 'is ' + this.msg,
    }
  },
  mounted() {
    //

    const permissions = JSON.parse(
      JSON.parse(localStorage.getItem('userInfo')).role.role_permession
        .permession
    )
    //
    if (permissions.alert.alert_pop_up_notification.sound) {
      // Play the audio
      const audioElement = this.$refs.audioElement
      audioElement.play()
    }
    // localStorage.setItem('alertList', this.initialTime)
    // window.setInterval(() => {
    //   alert('interval')
    //   let time = localStorage.getItem(this.alert_id)
    //   const now = new Date().getTime()
    // }, 5000)
    //
  },
  watch: {
    localStorage: {
      handler() {
        //
      },
      deep: true,
    },
  },
  data() {
    return {
      //   initialTime: 0,
    }
  },
  methods: {},
}
</script>

<style scoped></style>
